var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21055 16.8876V10.292H7.02022V16.8876H9.21055ZM8.11584 9.39164C8.87949 9.39164 9.35492 8.88517 9.35492 8.25224C9.34062 7.60488 8.87949 7.11255 8.13036 7.11255C7.38072 7.11255 6.89111 7.60488 6.89111 8.25218C6.89111 8.88512 7.36637 9.39158 8.10149 9.39158L8.11584 9.39164ZM10.4229 16.8876H12.6131V13.2047C12.6131 13.0078 12.6274 12.8105 12.6852 12.6699C12.8435 12.2759 13.2039 11.868 13.8091 11.868C14.6015 11.868 14.9186 12.4728 14.9186 13.3595V16.8876H17.1087V13.1059C17.1087 11.0801 16.0283 10.1374 14.5873 10.1374C13.4058 10.1374 12.887 10.7983 12.5987 11.2484H12.6133V10.2922H10.423C10.4516 10.911 10.4229 16.8876 10.4229 16.8876Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.982e88b3f2182c44d94d345671f5d119.svg";
export { ForwardRef as ReactComponent };